export default {
   login: 'Login',
   email: 'Email',
   password: 'Password',
   new_password: 'New Password',
   confirm_password: 'Confirm Password',
   incorrect_username_or_password: 'Incorrect Username or Password',
   loading: 'Loading ...',
   required: 'Required *',
   requests: 'Requests',
   request: 'Request',
   all_requests: 'All Requests',
   new_request: 'New Request',
   request_status: 'Request Status',
   inprogress: 'Inprogress',
   approved: 'Approved',
   rejected: 'Rejected',
   canceled: 'Canceled',
   completed: 'Completed',
   home: 'Home',
   setting: 'Setting',
   search: 'Search',
   my_tasks: 'My Tasks',
   my_history: 'My History',
   complete: 'Complete',
   form_builder: 'Form Builder',
   staff: 'Staff',
   requester_name: 'Requester Name',
   form_name: 'Form Name',
   priority: 'priority',
   step: 'step',
   date: 'Date',
   due_date: 'Due Date',
   date_and_time: 'Last Update date & time',
   preivew: 'preivew',
   add_message: 'Add Message',
   redirect_ticket: 'Redirect Ticket',
   approve: 'Approve',
   approvment: 'Approvment',
   decline: 'Decline',
   redirect: 'Redirect',
   save: 'Save',
   done: 'Done',
   delete: 'Delete',
   cancel: 'Cancel',
   back: 'Back',
   clear: 'Clear',
   reason_or_message: 'reason/message',
   no_approves_yet: 'No Approves yet',
   approved_by: 'Approved By',
   created_by: 'Created By',
   getway: 'Gateway',
   message: 'Message',
   attatchments: 'Attatchments',
   approved_requests: 'Approved Requests',
   completed_requests: 'Completed Requests',
   rejected_requests: 'Rejected Requests',
   id: 'ID',
   name: 'Name',
   full_name: 'Full Name',
   staff_number: 'Staff Number',
   department: 'Department',
   role: 'Role',
   manager: 'Manager',
   supervisor_in_order: 'Supervisor (in order)',
   permissons: 'Permissons',
   can_take_action: 'Can Take Action',
   can_generate_form: 'Can Generate Form',
   can_add_staff: 'Can Add Staff',
   can_set_priority: 'Can Set a Priority to the Request',
   can_redirect_request: 'Can Redirect The Request',
   can_see_all_tickets: 'Can See All Tickets',
   can_complete_request: 'Can Complete Request',
   staff_list: 'Staff List',
   add_new_staff: 'add new staff',
   edit_staff: 'Edit Staff',
   forms_list: 'Forms List',
   build_a_new_form: 'build a new form',
   form_general_info: 'Form General Info',
   form_preview: 'Form Preview',
   form_gatway: 'Form Gateway',
   reminder_days: 'Reminder Days',
   file_attachments: 'File Attachments',
   no_file_attachments: 'No File Attachments',
   allow_only_one_file_attachments: 'Allow only one File Attachments',
   allow_multiple_attachments: 'Allow multiple Attachments',
   please_select_a_staff: 'Please select a staff',
   select_the_staff_in_order: 'Select the staff (In Order)',
   staff_manager: 'Staff Manager',
   staff_supervisors: 'Staff Supervisors',
   select_the_staff: 'Select the staff',
   select_a_request: 'Select a request',
   add_the_form: 'Add the Form',
   confirm_discard_changes: 'Confirm Discard Changes',
   are_you_sure_you_want_to_do_this_action: 'Are you sure you want to do this action?',
   cannot_delete_this_form_bcz_it_has_an_open_tickets: "Can't delete this form because it has an open tickets",
   are_you_sure_you_want_to_discard_all_changes: 'Are you sure you want to discard all changes?',
   are_you_sure_you_need_to_add_this_form: 'Are you sure you need to add this form?',
   yes_add_it: 'Yes, Add it!',
   yes_delete_it: 'Yes, delete it!',
   yes_discard_changes: 'Yes, Discard Changes',
   please_set_the_form_name: 'Please set the form name',
   please_set_the_reminder_days: 'Please set the reminder days',
   please_select_the_file_attachments_type: 'Please select the file attachments type',
   please_complete_the_form: 'Please complete the form',
   please_confirm_the_password: 'Please confirm the password',
   password_not_match: 'Password not match',
   request_was_send: 'The request was send successfully',
   request_was_canceled: 'The request was canceled successfully',
   form_was_added: 'The form was added successfully',
   form_info_was_updated: 'The form info was updated successfully',
   form_was_deleted: 'The form was deleted successfully',
   staff_was_added: 'The staff was added successfully',
   staff_was_updated: 'The staff was updated successfully',
   request_was_approved: 'The request was approved successfully',
   request_was_declined: 'The request was declined successfully',
   request_was_completed: 'The request was completed successfully',
   request_was_redirected: 'The request was redirected successfully',
   your_data_was_updated_successfully: 'Your data was updated successfully',
   something_wrong: 'Something wrong!',
   normal: 'Normal',
   urgent: 'Urgent',
   top_urgent: 'Top Urgent',
   state: 'State',
   select_date_to_export: 'Select a Date To Export',
   please_select_date: 'Please Set a Date',
   invalid_date_range: 'Invalid date range',
   from_date: 'From Date: ',
   to_date: 'To Date: ',
   export: 'Export',
   selected_duration: 'Selected Duration',
   print: 'Print',
   directed_to: "Directed To",
   directed_by: "Directed By",
   ticket_number: "Ticket Number",
   opened_at: "Opened At",
   closed_at: "Closed At",
   forgetPass: "Forget Password",
   resetPassword: "Reset Password",
   forget_your_password: "Forget Your Password?",
   invalid_email: "Invalid Email",
   forget_pass_txt: "Please enter your email below and we will send you information to recover your account",
   add: "Add",
   add_file_attachment: "Add File Attachment",
   add_answer_form: "Add Answer Form",
   the_forms: "The Forms",
   the_answer_form: "The Answer Form",
   remove_the_answer_form: "Remove The Answer Form",
   show_the_answer_form: "Show The Answer Form",
   approve_this_request: "Approve this request",
   open_tickets: "Open Requests",
   closed_tickets: "Closed Requests",
   all_tickets: "All Requests",
   re_request: "Re-Request",
   answer_form: "Answer Form",
   loading_more: "Loading More",
   open_at: 'Open At',
   search_by_ticket_number: "Search by Ticket Number",
}